import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/13_waterfall/13_waterfall"
 * Contains 1 texture(s)
 */
export class Desktop13WaterfallAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/13_waterfall/13_waterfall';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '13_waterfall.jpg'
    ] as const;
}
